import { lazy, useEffect, useMemo, useRef } from 'react';
import { usePageStore } from '@/features/pages/stores/usePageStore';
import { usePageContentMutation } from '@/features/pages/hooks/usePageContentMutation';
import { Page } from '@/features/pages/types/page.types';
import { debounce } from 'lodash-es';

const NovelEditor = lazy(() => import('./Novel'));

const Editor = ({ page, enableEditing = true }: { page: Page; enableEditing?: boolean }) => {
  const editable = usePageStore(state => state.editable);
  const updatePageContent = usePageContentMutation();

  const onChangeRef = useRef((content: string) => {
    updatePageContent(page.id, content);
  });
  onChangeRef.current = (content: string) => {
    updatePageContent(page.id, content);
  };

  const debouncedUpdateContent = useMemo(
    () =>
      debounce((content: string) => {
        onChangeRef.current(content);
      }, 300),
    []
  );

  useEffect(
    () => () => {
      debouncedUpdateContent.cancel();
    },
    [debouncedUpdateContent]
  );

  return (
    <NovelEditor
      key={page.id}
      initialValue={page.content || ''}
      onChange={debouncedUpdateContent}
      enableEditing={enableEditing && editable && !page.archivedAt}
    />
  );
};

export default Editor;
